import { render, staticRenderFns } from "./IconView.vue?vue&type=template&id=071599b8&scoped=true"
import script from "./IconView.vue?vue&type=script&lang=js"
export * from "./IconView.vue?vue&type=script&lang=js"
import style0 from "./IconView.vue?vue&type=style&index=0&id=071599b8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071599b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('071599b8')) {
      api.createRecord('071599b8', component.options)
    } else {
      api.reload('071599b8', component.options)
    }
    module.hot.accept("./IconView.vue?vue&type=template&id=071599b8&scoped=true", function () {
      api.rerender('071599b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/cardHandling/components/IconView.vue"
export default component.exports